<!-- eslint-disable no-unused-vars -->
<template>
  <div class="mb-2">
    <div class="d-flex justify-content-between">
      <!-- filter -->
      <!-- <b-form-group class="mb-0">
        <b-input-group size="sm">
          <b-form-input
            size="sm"
            v-model="filter"
            type="search"
            placeholder="Tìm kiếm"
            @input="search"
          />
        </b-input-group>
      </b-form-group> -->
      <b-form-group class="ml-1 mb-0">
        <label
          >Tổng số: <span style="color: orange">{{ totalRows }} </span>cán
          bộ</label
        >
      </b-form-group>

      <b-form-group class="ml-1 mb-0">
        <b-button
          v-if="$can('create', 'DANHSACH')"
          size="sm"
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="primary"
          @click="$emit('show-edit', {})"
        >
          <feather-icon icon="PlusIcon" />
          Thêm mới
        </b-button>
      </b-form-group>
    </div>
    <!-- <div class="d-flex justify-content-end">
     
    </div> -->
    <!-- <b-row>
      <label class="text-right">Tổng số: {{ totalRows }}</label>
    </b-row> -->

    <!--start table -->
    <b-table
      striped
      hover
      responsive
      class="cs-table"
      :items="dataTable"
      :fields="fields"
      :sort-by.sync="sortBy"
      empty-text="Không có dữ liệu"
      table-class="vgt-table cs-table-info cs-table-reponsive"
    >
      <template #head(soCccd)="data">
        <span>{{ data.label.toUpperCase() }} <span>Ngày sinh</span></span>
      </template>
      <template #cell(hoVaTen)="data">
        <b-media vertical-align="center">
          <template #aside>
            <b-avatar
              size="32"
              :src="url + data.item.avatar"
              :text="avatarText(data.value)"
              :variant="`light-${resolveUserRoleVariant(data.item.unitRole)}`"
              :to="{
                name: 'canbocongchuc-thongtin',
                params: { id: data.item.id },
              }"
            />
          </template>
          <b-link
            :to="{
              name: 'canbocongchuc-thongtin',
              params: { id: data.item.id },
            }"
            class="font-weight-bold d-block text-nowrap"
          >
            {{ data.value }}
          </b-link>
          <small class="text-muted">@{{ data.item.email }}</small>
        </b-media>
      </template>
      <template #cell(donVi)="data">
        <b-badge
          :variant="`light-${resolveUserStatusVariant(data.value.code)}`"
          class="text-capitalize"
        >
          <p class="truncate1 mb-0">{{ data.value.ten }}</p>
        </b-badge>
      </template>
      <template #cell(soCccd)="data">
        <span v-if="data.value">{{ data.value }}</span>
        <span v-else>{{ data.item.soCmnd }}</span>
        <p v-if="data.item.ngaySinh">
          {{ new Date(data.item.ngaySinh) | moment("DD/MM/YYYY") }}
        </p>
        <p v-else></p>
      </template>
      <template #cell(chucVu)="data">
        {{ data.value.name }}
      </template>
      <template #cell(trangThaiHoSo)="data">
        <b-badge
          :variant="`light-${resolveUserStatusVariant(data.value.code)}`"
          class="text-capitalize"
          >{{ data.value.name }}</b-badge
        >
      </template>

      <template #cell(dongBo)="data">
        <b-badge
          :variant="`light-${resolveDongBoVariant(
            data.item.isSync,
            data.item.isUpdatedSyncQuocGia
          )}`"
          class="text-capitalize"
        >
          {{
            resolveDongBoName(data.item.isSync, data.item.isUpdatedSyncQuocGia)
          }}
        </b-badge>
      </template>
      <template #cell(action)="row">
        <div class="demo-inline-spacing">
          <b-button
            :to="{
              name: 'canbocongchuc-thongtin',
              params: { id: row.item.id },
            }"
            variant="flat-success"
            class="btn btn-icon p-50 m-0 btn-cs"
            v-b-tooltip.hover.top="'Chi tiết'"
          >
            <feather-icon icon="SendIcon" size="16" />
          </b-button>
          <b-dropdown
            v-if="$can('update', 'DANHSACH') || $can('delete', 'DANHSACH')"
            variant="link"
            toggle-class="text-decoration-none btn-cs"
            no-caret
            class="p-0 m-0"
          >
            <template v-slot:button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="text-body align-middle"
                v-b-tooltip.hover.top="'Công cụ'"
              />
            </template>

            <b-dropdown-item
              v-if="$can('update', 'DANHSACH')"
              @click="showEdit(row.item)"
            >
              <feather-icon icon="Edit2Icon" class="mr-50" />
              <span>Sửa</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="$can('delete', 'DANHSACH')"
              @click="showConfirmDeleteModule(row.item)"
            >
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span>Xoá</span>
            </b-dropdown-item>
          </b-dropdown>
          <feather-icon
            v-if="row.detailsShowing"
            @click="row.toggleDetails"
            class="mt-0 mr-0 btn-cs"
            icon="ChevronsUpIcon"
            size="24"
            v-b-tooltip.hover.top="'Xem thêm'"
          />
          <feather-icon
            v-else
            @click="row.toggleDetails"
            class="mt-0 mr-0 btn-cs"
            icon="ChevronsDownIcon"
            size="24"
            v-b-tooltip.hover.top="'Xem thêm'"
          />
        </div>
      </template>

      <!-- full detail on click -->
      <template #row-details="row">
        <div class="px-1"><hr /></div>
        <div class="d-flex py-1">
          <div class="mr-2">
            <i class="fa-solid fa-circle-info fa-2x text-warning"></i>
          </div>
          <div class="w-100">
            <div class="row">
              <div class="col-lg-3 col-md-6 col-sm-12">
                <div>
                  <p class="mb-50">Cơ quan quản lý</p>
                  <p class="font-weight-bold text-black">
                    {{
                      row.item.donViQuanLy
                        ? row.item.donViQuanLy.ten
                        : "Chưa rõ"
                    }}
                  </p>
                </div>
                <div>
                  <p class="mb-50">Cơ quan sử dụng</p>
                  <p class="font-weight-bold text-black">
                    {{ row.item.donVi ? row.item.donVi.ten : "Chưa rõ" }}
                  </p>
                </div>
                <div>
                  <p class="mb-50">Chức vụ</p>
                  <p class="font-weight-bold text-black">
                    {{ row.item.chucVu ? row.item.chucVu.name : "Chưa rõ" }}
                  </p>
                </div>
                <div>
                  <p class="mb-50">Đối tượng (Loại hồ sơ)</p>
                  <p class="font-weight-bold text-black">
                    {{ row.item.loaiHoSo ? row.item.loaiHoSo.name : "Chưa rõ" }}
                  </p>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12">
                <div>
                  <p class="mb-50">Ngày vào cơ quan hiện tại</p>
                  <p class="font-weight-bold text-black">
                    {{ new Date(row.item.ngayDamNhiem) | moment("DD/MM/YYYY") }}
                  </p>
                </div>
                <div>
                  <p class="mb-50">Phòng ban</p>
                  <p class="font-weight-bold text-black">
                    {{ row.item.phongBan ? row.item.phongBan.name : "Chưa rõ" }}
                  </p>
                </div>
                <div>
                  <p class="mb-50">Công việc chính</p>
                  <p class="font-weight-bold text-black">
                    {{
                      row.item.congViecChinh
                        ? row.item.congViecChinh
                        : "Chưa rõ"
                    }}
                  </p>
                </div>
                <div>
                  <p class="mb-50">Vai trò</p>
                  <p class="font-weight-bold text-black">
                    {{
                      row.item.unitRole ? row.item.unitRole.name : "Chưa rõ "
                    }}
                  </p>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12">
                <div>
                  <p class="mb-50">Số hiệu CBCCVC</p>
                  <p class="font-weight-bold text-black">
                    {{
                      row.item.soHieuCBCCVC ? row.item.soHieuCBCCVC : "Chưa rõ"
                    }}
                  </p>
                </div>
                <div>
                  <p class="mb-50">Trình độ giáo dục phổ thông</p>
                  <p class="font-weight-bold text-black">
                    {{
                      row.item.giaoDucPhoThong
                        ? row.item.giaoDucPhoThong.name
                        : "Chưa rõ"
                    }}
                  </p>
                </div>
                <div>
                  <p class="mb-50">Giới tính</p>
                  <p class="font-weight-bold text-black">
                    {{ row.item.gioiTinh ? row.item.gioiTinh.name : "Chưa rõ" }}
                  </p>
                </div>
                <div>
                  <p class="mb-50">Dân tộc</p>
                  <p class="font-weight-bold text-black">
                    {{ row.item.danToc ? row.item.danToc.name : "Chưa rõ" }}
                  </p>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12">
                <div>
                  <p class="mb-50">Tôn giáo</p>
                  <p class="font-weight-bold text-black">
                    {{ row.item.tonGiao ? row.item.tonGiao.name : "Chưa rõ" }}
                  </p>
                </div>
                <div>
                  <p class="mb-50">Tình trạng hôn nhân</p>
                  <p class="font-weight-bold text-black">
                    {{
                      row.item.tinhTrangHonNhan
                        ? row.item.tinhTrangHonNhan.name
                        : " Chưa rõ"
                    }}
                  </p>
                </div>
                <div>
                  <p class="mb-50">Nơi ở hiện nay</p>
                  <p class="font-weight-bold text-black">
                    {{
                      row.item.hoKhauThuongTru.fullAddress
                        ? row.item.hoKhauThuongTru.fullAddress
                        : "Chưa rõ"
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-table>
    <!--end table -->

    <div class="d-flex justify-content-between">
      <!-- page length -->

      <b-form-group class="text-nowrap mb-md-0 mr-1">
        Hiển thị
        <label class="d-inline-flex align-items-center">
          <b-form-select
            id="perPageSelect"
            class="form-select form-select-sm"
            v-model="perPage"
            size="sm"
            inline
            :options="perPageOptions"
            @input="showPerPage"
          />
        </label>
        trên tổng số {{ totalRows }} dòng
      </b-form-group>
      <!-- pagination -->
      <div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          class="mb-0"
          @input="pagination"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  VBTooltip,
  BRow,
  BCol,
  BTable,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BButton,
  BCardBody,
  BFormCheckbox,
  BAvatar,
  BBadge,
  BMedia,
  BLink,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import { avatarText } from "@core/utils/filter";
import useSetup from "./../useSetup";
import store from "@/store/index";
import { CanBoCongChucDelete as DeleteData } from "@/services/api/HoSoCanBoCongChuc/CanBoCongChucService";

export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BTable,
    BCard,
    BCardBody,
    BButton,
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BAvatar,
    BMedia,
    BLink,
    BBadge,
    BInputGroup,
    BInputGroupAppend,
  },
  props: {
    dataTable: {
      type: Array,
      required: true,
    },
    isLoaded: {
      type: Boolean,
      required: true,
    },
    searchRef: {
      type: Object,
      default: { value: "" },
    },
    totalRows: {
      type: Number,
      required: true,
    },
    dataMeta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isWait: false,
      // pageLength: 10,
      dir: false,

      searchTerm: "",

      //=======

      // perPage: 10,
      // pageOptions: [10, 20, 50],
      // totalRows: 1,
      // currentPage: 1,

      filter: null,
      filterOn: [],

      fields: [
        // {
        //   key: 'STT',
        //   label: 'STT',
        //   class: 'text-center',
        //   thStyle: 'width:50px',
        //   // tdStyle: "text-align: center;",
        // },
        {
          key: "hoVaTen",
          label: "Họ và tên",
          sortable: true,
        },
        {
          key: "donVi",
          label: "Cơ quan sử dụng",
          class: "",
          thStyle: "width:180px",
        },
        {
          key: "soCccd",
          label: "CCCD/CMND",
          class: "",
          thStyle: "width:150px",
        },
        {
          key: "chucVu",
          label: "Chức vụ",
          thStyle: "width:150px",
        },
        {
          key: "trangThaiHoSo",
          label: "Trạng thái HS",
          class: "",
          thStyle: "width:150px",
        },
        {
          key: "dongBo",
          label: "Đồng bộ",
          class: "",
          thStyle: "width:100px",
        },
        {
          key: "action",
          label: "#",
          thStyle: "text-align:center; width:150px",
          tdClass: "",
        },
      ],
      url: process.env.VUE_APP_BASE_API + "/files/view/",
    };
  },
  watch: {
    sortBy() {
      this.$emit("sort-by", this.sortBy);
    },
  },

  methods: {
    pagination(val) {
      // console.log("val", val);
      this.$emit("update-pagination", val);
    },
    showPerPage(val) {
      this.$emit("update-perpage", val);
    },

    // search(val) {
    //   // console.log(val);
    //   this.$emit("update-searchquery", val);
    // },

    // onFiltered(filteredItems) {
    //   // Trigger pagination to update the number of buttons/pages due to filtering
    //   this.totalRows = filteredItems.length;
    //   this.currentPage = 1;
    // },
    //--------

    showEdit(data) {
      // console.log("show-edit", data);
      this.$emit("show-edit", JSON.parse(JSON.stringify(data)));
    },

    showConfirmDeleteModule(data) {
      if (this.isWait) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Notification",
            icon: "CoffeeIcon",
            variant: "info",
            text: "In Progress",
          },
        });
      } else {
        this.$bvModal
          .msgBoxConfirm("Xác nhận xoá", {
            okTitle: "Đồng ý",
            cancelTitle: "Hủy",
            cancelVariant: "outline-secondary",
          })
          .then((value) => {
            if (value) {
              this.isWait = true;
              DeleteData({
                id: data.id,
              }).then((res) => {
                this.isWait = false;
                if (res.isError) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Thất bại",
                      icon: "AlertTriangleIcon",
                      variant: "error",
                      text: res.message,
                    },
                  });
                } else {
                  this.$emit("remove-item", data);
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Thành công",
                      icon: "CheckIcon",
                      variant: "success",
                      text: res.message,
                    },
                  });
                }
              });
            }
          });
      }
    },
  },
  setup(props, { emit }) {
    const {
      refListTable,
      perPage,
      currentPage,
      perPageOptions,
      sortBy,
      isSortDirDesc,
    } = useSetup();
    const resolveUserRoleVariant = (role) => {
      if (role != null && role.code) {
        if (role.code === "ND") return "primary";
        if (role.code === "LDTDV") return "warning";
        if (role.code === "LDTPB") return "success";
        if (role.code === "LDSNV") return "info";
        if (role.code === "ADMIN") return "danger";
        return "primary";
      }
      return "primary";
    };
    const resolveUserStatusVariant = (status) => {
      if (status === "01") return "success";
      if (status === "00") return "warning";
      if (status === "04") return "secondary";
      return "success";
    };
    const resolveDongBoVariant = (isSync, status) => {
      if (isSync === false) {
        return "warning";
      } else {
        if (status === true) return "success";
        else return "danger";
      }
    };
    const resolveDongBoName = (isSync, status) => {
      if (isSync === false) {
        return "Không đồng bộ";
      } else {
        if (status === true) return "Thành công";
        else return "Thất bại";
      }
    };
    // watch([sortBy], () => {
    //   console.log("-------", sortBy.value);
    // });
    return {
      refListTable,
      perPage,
      currentPage,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      avatarText,
      resolveUserRoleVariant,
      resolveUserStatusVariant,
      resolveDongBoVariant,
      resolveDongBoName,
      // dataTable,
      // dataTableIsLoaded,
      // searchTerm,
    };
  },
};
</script>
